import { motion } from "framer-motion";
import { EllieOrb } from "@/components/discovery/EllieOrb";
import { journey } from "@/lib/journey";

const COPY = {
  unsaid: "Let's begin with The Unsaid. It's a space to put words to what you've been feeling or carrying — including the things that are hard to say out loud. Answer however feels true; short answers are completely fine.",
  xray: "Next is your Emotional X-Ray. I've looked across everything you shared for possible patterns and connections. These are observations, not conclusions — you decide what fits.",
  plan: "Now let's make this practical. Your Daily Battle Plan turns what we've uncovered into three achievable targets for today, plus one thing worth watching out for.",
  future: "This next part is personal. Future Self lets you talk with the version of you one year from now — someone who has kept moving toward what you care about.",
  purpose: "Last stop: the Purpose Engine. We'll explore what gives your life meaning and the direction you want to move toward, building on everything you've shared.",
};

// Ellie's short, conversational introduction before each feature — only inside the guided journey.
export const EllieBridge = ({ feature, className = "" }) => {
  if (!journey.isOn() || !COPY[feature]) return null;
  return (
    <motion.div data-testid={`ellie-bridge-${feature}`} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
      className={`fio-glass fio-hairline flex items-start gap-3 rounded-3xl p-4 text-left ${className}`}>
      <EllieOrb size={40} testId={`ellie-bridge-${feature}-avatar`} />
      <div>
        <p className="eyebrow text-[10.5px] text-teal-700">Ellie</p>
        <p className="mt-1 text-[14.5px] leading-relaxed text-slate-700">{COPY[feature]}</p>
      </div>
    </motion.div>
  );
};
